import type { StructuredCollectionConfig } from '@ltvco/refresh-lib/hooks';

/**
 * Collections used by the Immigration Records.
 *
 * IMPORTANT:
 * - The order of this list must match the order defined in Remoulade.
 * - Do not reorder existing collections, as the position is used to maintain
 *   consistency with Remoulade mappings and processing logic.
 * - When adding a new collection, append it to the end of the array.
 * - Existing entries should remain in their current positions.
 *
 * The primary event date (immigration arrival) is built generically by
 * buildExtraFields for immigrants_index from the user-selected event.
 */
export const IMMIGRANTS_INDEX_COLLECTIONS: StructuredCollectionConfig[] = [
  {
    id: '0000043',
    plainName: 'United States, Immigrants from DE, FR, and CH, 1820-1907',
    type: 'immigrants_index',
    source: 'immigrationRecordsSearch',
    reportType: 'immigrants_indexes',
    ga4ReportType: 'us_immigrants_from_de_fr_and_ch',
    yearStart: 1820,
    yearEnd: 1907,
    // No separate middle-name field for this collection.
    options: { combineFirstMiddleName: true },
    events: [
      {
        name: 'Immigration',
        isRange: false,
      },
    ],
    isV2: true,
  },
  {
    id: '0000044',
    plainName:
      'United States, Passenger Manifest Lists of Immigrants from the United Kingdom and Ireland, 1832-1902',
    type: 'immigrants_index',
    source: 'immigrationRecordsSearch',
    reportType: 'immigrants_indexes',
    ga4ReportType: 'us_immigrants_from_uk_and_ie',
    yearStart: 1832,
    yearEnd: 1902,
    // No separate middle-name field; no searchable birth/death dates.
    options: { combineFirstMiddleName: true },
    events: [
      {
        name: 'Immigration',
        isRange: false,
      },
    ],
    isV2: true,
  },
];
